export enum taskPaths {
	MAIN = ':taskId',
	TASK_INCOMING = 'task-incoming',
	TASK_INCOMING_TASK = 'task-incoming/:projectId/:taskId',
}
